module.exports = __webpack_public_path__ + "media/images/pc/page_common/banner/banner_costumes-4789076d2ee055a3d8cf773059d4bda2.webp";